module.exports = __webpack_public_path__ + "static/img/katun01.3643293.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/katun01.jpg
// module id = hTbT
// module chunks = 0